export default __webpack_public_path__ + "static/media/Projects2.57c64a49.png";